import { createBrowserHistory } from 'history'
const history = typeof window !== 'undefined' ? createBrowserHistory() : null

import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'
import RecomendedNg from './../block/RecomendedNg'
import FeedbackNg from './../block/FeedbackNg'
import Lists from './../block/ListsProductPage'

import axios from 'axios'

import ClientOnlySlider from '../block/ClientOnlySlider';

import queryString from 'query-string'

import { Container, Card, Row, Col, Form, Pagination as BPagination, Button, OverlayTrigger, Tooltip, Spinner, DropdownButton, Dropdown, Offcanvas } from 'react-bootstrap'

import 'rc-slider/assets/index.css'
import styles from './../blocks.module.sass'

if (typeof window !== 'undefined') {
  const history = createBrowserHistory()
} else {
  const history = false
}

export default class Razdel extends Component {

  constructor(props) {
    super(props)

    this.myRef = createRef()

    const { ajax_data, catalogmenu } = props,
    { start } = ajax_data

    const products = start?.products || null,
    count = start?.count || 0,
    page = start?.page || 1,
    vsego = start?.vsego || 0,
    zapros = start?.zapros || ''

    var catalogmenuKey = 0,
    catalogmenuKeyChild = 0

    if('parents' in ajax_data) {
      catalogmenu?.map(( elm ) => {
        if( ajax_data.parents.includes( elm.id ) ) {
          catalogmenuKey = elm.id
          elm.child?.map(( celm ) => {
            if( ajax_data.parents.includes( celm.id ) ) {
              catalogmenuKeyChild = elm.id
            }
          })
        }
      })
    }

    this.state = {
      products: products,
      count: count,
      page: page,
      vsego: vsego,
      zapros: zapros,
      filter_titles: {
        dir: true,
        price: true,
        color: true,
        size: true,
        nalichie: true
      },
      catalogmenuKey: catalogmenuKey,
      catalogmenuKeyChild: catalogmenuKeyChild,
      size: ``,
      color: ``,
      min_price: 0,
      max_price: props.ajax_data.max_price,
      sortVal: `updated_asc`,
      sortName: `новинки`,
      show: false,
      recomended: [],
      nalichie: `all`,
      loading: false,
      firstClickId: 0
    }
  }

  changeSort = ( val, name ) => {
    this.setState({
      sortVal: val,
      sortName: name,
      products: null
    }, () => {
      this.loadProducts()
    })
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '' || price == null) return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  loadProducts = () => {
    const { min_price, max_price, color, size, page, sortVal, nalichie } = this.state

    const baseURL = window.location.protocol + "//" + window.location.hostname,
    pathname = window.location.pathname,
    main = this

    this.setState({
      loading: true
    }, () => {
      axios.post(`${baseURL}${pathname}`, {
        'content_type': 'application/json',
        'action': 'load_products_razdel',
        'min': min_price,
        'max': max_price,
        'color': color,
        'size': size,
        'page': page,
        'sort': sortVal,
        'nalichie': nalichie
      }).then( ( response ) => {
        main.setState({
          products: response.data.products,
          count: response.data.count,
          page: response.data.page,
          vsego: response.data.vsego,
          zapros: response.data.zapros,
          loading: false
        })
      })
    })
  }

  changeFTitles = ( key ) => {
    const { filter_titles } = this.state
    filter_titles[ key ] = !filter_titles[ key ]
    this.setState({
      filter_titles: filter_titles
    })
  }

  changeCatalogmenuKeyChild = ( key ) => {
    const { catalogmenuKeyChild } = this.state
    this.setState({
      catalogmenuKeyChild: catalogmenuKeyChild == key ? null : key
    })
  }

  changeCatalogmenuKey = ( key ) => {
    const { catalogmenuKey } = this.state
    this.setState({
      catalogmenuKey: catalogmenuKey == key ? null : key
    })
  }

  submitFilter = () => {
    if(this.timer) clearTimeout(this.timer)
    const main = this
    this.timer = setTimeout(function() {
      main.setState({
        page: 1,
        products: null,
        count: 0,
        vsego: 0
      }, () => {
        main.changePath()
        //main.loadProducts()
        if( main.myRef ) main.myRef.current.scrollIntoView()
      })
    }, 500)
  }

  rangeUpdate(arr) {
    this.setState( {
        min_price: arr[0],
        max_price: arr[1]
    }, () => {
      this.submitFilter()
    })
  }

  setColor = ( val ) => {
    const { color } = this.state
    this.setState( {
      color: val == color ? `` : val
    }, () => {
      this.submitFilter()
    })
  }

  setSize = ( val ) => {
    const { size } = this.state
    this.setState( {
      size: val == size ? `` : val
    }, () => {
      this.submitFilter()
    })
  }

  inCart = ( id ) => {
    const { cart } = this.props
    var fined = false
    cart.map(( celm ) => {
      if( celm.resource == id ) {
        fined = true
      }
    })
    return fined
  }

  changePath = () => {
    const { ajax_data } = this.props,
    { page, size, color, min_price, max_price, nalichie } = this.state,
    baseURL = window.location.protocol + "//" + window.location.hostname,
    pathname = window.location.pathname

    var search = {}
    if( page > 1 ) search.page = page
    if( size != '' ) search.size = size
    if( color != '' ) search.color = color
    if( nalichie != 'all' ) search.nalichie = nalichie
    if( Number( min_price ) > 0 ) search.min = Number( min_price )
    if( Number( max_price ) < Number( ajax_data.max_price ) ) search.max = Number( max_price )
    var search_string = queryString.stringify( search, {arrayFormat: 'separator', arrayFormatSeparator: '|'} )

    if(history) history.push( `${baseURL}${pathname}` + ( search_string != '' ? `?` + search_string : `` ) )
  }

  changePage = ( e, num ) => {
    const { page } = this.state,
    main = this

    e.preventDefault()

    if(num == page) return

    this.setState({
      page: num
    }, () => {
      this.changePath()
      //this.loadProducts()
      if( main.myRef ) main.myRef.current.scrollIntoView()
    })
  }

  handleShow() {
    this.setState({
      show: true
    })
  }

  handleClose() {
    this.setState({
      show: false
    })
  }

  getSearchParams = () => {
    const { ajax_data } = this.props

    var search_arr = queryString.parse( window.location.search, {
      types: {
        page: 'number',
        size: 'string',
        color: 'string',
        min: 'number',
        max: 'number'
      }
    } )
    this.setState({
      page: search_arr.page ? search_arr.page : 1,
      size: search_arr.size ? search_arr.size : ``,
      color: search_arr.color ? search_arr.color : ``,
      min_price: search_arr.min ? search_arr.min : 0,
      max_price: search_arr.max ? search_arr.max : ajax_data.max_price,
      nalichie: search_arr.nalichie ? search_arr.nalichie : `all`,
    }, () => {
      this.loadProducts()
    })
  }

  loadRecomended = () => {
    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this

    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'load_products_ng',
      'variant': `rend`,
      'page': 1
    }).then( ( response ) => {
      main.setState({
        recomended: response.data.products
      })
    })
  }

  setNalichie = ( val ) => {
    this.setState({
      nalichie: val
    }, () => {
      this.changePath()
    })
  }

  componentDidMount() {
    const { new_page } = this.props

    if( new_page ) this.loadRecomended()

    if(history) {
      history.listen(() => {
        this.getSearchParams()
      })
    }
  }

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, favorite, cart, showInCart, in_cart_loading, changeFavorite, catalogmenu, new_page } = this.props,
    { filter_titles, catalogmenuKey, catalogmenuKeyChild, min_price, max_price, color, size, count, vsego, products, page, zapros, sortName, show, recomended, nalichie, loading } = this.state

    const filtr = (
      <div className={styles.razdel_leftfilter}>
        <div onClick={() => this.changeFTitles( 'nalichie' )} className={filter_titles.nalichie ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
          <div>Наличие</div>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="black"/>
          </svg>
        </div>
        <div className={filter_titles.nalichie ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
          <div onClick={() => this.setNalichie( `all` )} className={styles.razdel_leftfilter_content_color}>
            <div className='d-flex align-items-center'>
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                {nalichie == `all` &&
                  <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                }
              </svg>
              <div className={nalichie == `all` ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Показать все</div>
            </div>
          </div>
          <div onClick={() => this.setNalichie( `sklad` )} className={styles.razdel_leftfilter_content_color}>
            <div className='d-flex align-items-center'>
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                {nalichie == `sklad` &&
                  <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                }
              </svg>
              <div className={nalichie == `sklad` ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>В наличии</div>
            </div>
          </div>
        </div>
        <div onClick={() => this.changeFTitles( 'dir' )} className={filter_titles.dir ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
          <div>Категория</div>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="black"/>
          </svg>
        </div>
        <div className={filter_titles.dir ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
          <div className={styles.razdel_leftfilter_content_accordion}>
            {catalogmenu.map((elm, k) => {
              if(elm.child != null) return (
                <div key={k} className={styles.razdel_leftfilter_content_accordion_el}>
                  <div onClick={() => this.changeCatalogmenuKey(elm.id  )} className={catalogmenuKey == elm.id ? styles.razdel_leftfilter_content_accordion_el_header_open : styles.razdel_leftfilter_content_accordion_el_header}>
                    <a className='d-none d-lg-inline' href={elm.url}>{elm.name}</a>
                    {catalogmenuKey == elm.id ?
                      <a className='d-lg-none' href={elm.url}>{elm.name}</a>
                    :
                      <div className='d-lg-none'>{elm.name}</div>
                    }
                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6 6L11 1" stroke="black"/>
                    </svg>
                  </div>
                  <div className={catalogmenuKey == elm.id ? styles.razdel_leftfilter_content_accordion_el_body_open : styles.razdel_leftfilter_content_accordion_el_body}>
                    {elm.child.map((celm, j) => {
                      if('parents' in ajax_data) return (
                        <>
                          <div key={j}>
                            {ajax_data.parents.includes( celm.id ) ?
                              <>
                                <a href={celm.url} className={styles.razdel_leftfilter_content_accordion_el_1_active}>
                                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                    <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                                  </svg>
                                  <div>{celm.name}</div>
                                </a>
                                {celm.child.map((ccelm, i) => {
                                  return (
                                    <a key={i} className={ajax_data.parents.includes( ccelm.id ) ? styles.razdel_leftfilter_content_accordion_el_2_active : styles.razdel_leftfilter_content_accordion_el_2} href={ccelm.url}>{ccelm.name}</a>
                                  )
                                })}
                              </>
                            :
                              <>
                                {celm.child.length == 0 ?
                                  <a href={celm.url} className={styles.razdel_leftfilter_content_accordion_el_1}>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                    </svg>
                                    <div>{celm.name}</div>
                                  </a>
                                :
                                  <>
                                    {catalogmenuKeyChild == celm.id ?
                                      <>
                                        <a href={celm.url} className={styles.razdel_leftfilter_content_accordion_el_1}>
                                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                          </svg>
                                          <div>{celm.name}</div>
                                        </a>
                                        {celm.child.map((ccelm, i) => {
                                          return (
                                            <a key={i} className={ajax_data.parents.includes( ccelm.id ) ? styles.razdel_leftfilter_content_accordion_el_2_active : styles.razdel_leftfilter_content_accordion_el_2} href={ccelm.url}>{ccelm.name}</a>
                                          )
                                        })}
                                      </>
                                    :
                                      <span style={{ cursor: `pointer` }} onClick={() => this.changeCatalogmenuKeyChild( celm.id )} className={styles.razdel_leftfilter_content_accordion_el_1}>
                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                        </svg>
                                        <div>{celm.name}</div>
                                      </span>
                                    }
                                  </>
                                }
                              </>
                            }
                          </div>
                        </>
                      )
                    })}
                  </div>
                </div>
              )
            })}
            <div className={styles.razdel_leftfilter_content_accordion_el}>
              <div className={styles.razdel_leftfilter_content_accordion_el_header}>
                <a href={page_data.poshiv_link}>Индивидуальный пошив</a>
                <div> </div>
              </div>
            </div>
            <div className={styles.razdel_leftfilter_content_accordion_el}>
              <div className={styles.razdel_leftfilter_content_accordion_el_header}>
                <a href={page_data.karti_link}>Подарочные карты</a>
                <div> </div>
              </div>
            </div>
            <div className={styles.razdel_leftfilter_content_accordion_el}>
              <div className={styles.razdel_leftfilter_content_accordion_el_header}>
                <a href={page_data.new_link}>Новые поступления</a>
                <svg style={{ marginRight: `auto`, marginLeft: `12px` }} width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="3" cy="3" r="3" fill="#DA0000"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
        {'max_price' in ajax_data &&
          <>
            {ajax_data.max_price > 0 &&
              <>
                <div onClick={() => this.changeFTitles( 'price' )} className={filter_titles.price ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
                  <div>Цена</div>
                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="black"/>
                  </svg>
                </div>
                <div className={filter_titles.price ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
                  {typeof window !== 'undefined' && (
                    <ClientOnlySlider
                      range
                      min={0}
                      max={Number( ajax_data.max_price )}
                      value={[min_price, max_price]}
                      onChange={(e) => this.rangeUpdate(e)}
                    />
                  )}
                  <Row>
                    <Col xs="6">
                      <Form.Group>
                        <Form.Label className={styles.razdel_leftfilter_pricetitle}>От</Form.Label>
                        <Form.Control className={styles.razdel_leftfilter_priceinput} type="text" onChange={(e) => this.rangeUpdate([ Number( e.target.value ), max_price ])} value={min_price} />
                      </Form.Group>
                    </Col>
                    <Col xs="6">
                      <Form.Group>
                        <Form.Label className={styles.razdel_leftfilter_pricetitle}>До</Form.Label>
                        <Form.Control className={styles.razdel_leftfilter_priceinput} type="text" onChange={(e) => this.rangeUpdate([ min_price, Number( e.target.value ) ])} value={max_price} />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </>
            }
          </>
        }
        {'colors' in ajax_data &&
          <>
            {ajax_data.colors.length > 0 &&
              <>
                <div onClick={() => this.changeFTitles( 'color' )} className={filter_titles.color ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
                  <div>Цвет</div>
                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="black"/>
                  </svg>
                </div>
                <div className={filter_titles.color ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
                  {ajax_data.colors.map(( elm, k ) => {
                    return (
                      <div onClick={() => this.setColor( elm.name )} key={k} className={styles.razdel_leftfilter_content_color}>
                        <div className='d-flex align-items-center'>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                            {elm.name == color &&
                              <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                            }
                          </svg>
                          <div className={elm.name == color ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>{elm.name}</div>
                        </div>
                        {elm.color != '' &&
                          <div className={styles.razdel_leftfilter_content_color_color} style={{ backgroundColor: elm.color }}></div>
                        }
                      </div>
                    )
                  })}
                </div>
              </>
            }
          </>
        }
        {'sizes' in ajax_data &&
          <>
            {ajax_data.sizes.length > 0 &&
              <>
                <div onClick={() => this.changeFTitles( 'size' )} className={filter_titles.size ? styles.razdel_leftfilter_title_open : styles.razdel_leftfilter_title}>
                  <div>Размер</div>
                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="black"/>
                  </svg>
                </div>
                <div className={filter_titles.size ? styles.razdel_leftfilter_content_open : styles.razdel_leftfilter_content}>
                  <Row>
                    {ajax_data.sizes.map(( elm, k ) => {
                      return (
                        <Col key={k} xs="6">
                          <div onClick={() => this.setSize( elm )} className={styles.razdel_leftfilter_content_color}>
                            <div className='d-flex align-items-center'>
                              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                {elm == size &&
                                  <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                                }
                              </svg>
                              <div className={elm == size ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>{elm}</div>
                            </div>
                          </div>
                        </Col>
                      )
                    })}
                    <Col xs="6">
                      <div onClick={() => this.setSize( `` )} className={styles.razdel_leftfilter_content_color}>
                        <div className='d-flex align-items-center'>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                            {`` == size &&
                              <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                            }
                          </svg>
                          <div className={`` == size ? styles.razdel_leftfilter_content_color_name_active : styles.razdel_leftfilter_content_color_name}>Все размеры</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </>
            }
          </>
        }
      </div>
    )

    const close_filters = (
      <div className={styles.razdel_rcontent_filter}>
        <div>Фильтры: </div>
        {'filer_crumb_dirs' in ajax_data &&
          <>
            {ajax_data.filer_crumb_dirs.length > 0 &&
              <>
                {ajax_data.filer_crumb_dirs.map((elm, k) => {
                  return (
                    <a className={styles.razdel_rcontent_filter_elm} key={k} href={elm.url}>
                      <div>{elm.name}</div>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L9 9" stroke="black"/>
                        <path d="M9 1L1 9" stroke="black"/>
                      </svg>
                    </a>
                  )
                })}
              </>
            }
          </>
        }
        {size != `` &&
          <div className={styles.razdel_rcontent_filter_elm} onClick={() => this.setSize(``)}>
            <div>Размер: {size}</div>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L9 9" stroke="black"/>
              <path d="M9 1L1 9" stroke="black"/>
            </svg>
          </div>
        }
        {'max_price' in ajax_data &&
          <>
            {min_price + max_price != ajax_data.max_price &&
              <div className={styles.razdel_rcontent_filter_elm} onClick={() => this.rangeUpdate([ 0, Number( ajax_data.max_price ) ])}>
                <div>{this.priceFormat( min_price )} ₽ - {this.priceFormat( max_price )} ₽</div>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L9 9" stroke="black"/>
                  <path d="M9 1L1 9" stroke="black"/>
                </svg>
              </div>
            }
          </>
        }
        {color != `` &&
          <div className={styles.razdel_rcontent_filter_elm} onClick={() => this.setColor(``)}>
            <div>Цвет: {color}</div>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L9 9" stroke="black"/>
              <path d="M9 1L1 9" stroke="black"/>
            </svg>
          </div>
        }
      </div>
    )

    return (
      <>
        <HeaderPage
          ajax_data={ajax_data}
          page_data={page_data}
          changeTopSearch={changeTopSearch}
          changeLeftMenuh={changeLeftMenuh}
          favorite={favorite}
          cart={cart}
        />
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null ?
            <>
              {'bc' in ajax_data &&
                <Breadcrumbs
                  pages={[
                    ...ajax_data.bc,
                    {
                      name: ajax_data.longtitle ? ajax_data.longtitle : ajax_data.pagetitle,
                      current: true
                    }
                  ]}
                />
              }
              <div className={styles.razdel_contener}>
                <Container>
                  <h1 ref={this.myRef} className={styles.razdel_newtitle + ' text-center'}>{ajax_data.seo_h1}</h1>
                  <div className={styles.razdel_contener_fp}>
                    <div className='d-none d-lg-block'>{filtr}</div>
                    <div className='d-lg-none'>{close_filters}</div>
                    <div className={styles.razdel_rcontent}>
                      {products != null &&
                        <div className={styles.razdel_rcontent_topstr}>Показано <span>{products.length} товаров из {vsego}</span>{zapros != `` && <> по запросу “<span>{zapros}</span>”</>}</div>
                      }
                      <div className='d-flex align-items-center justify-content-between'>
                        <div className='d-none d-lg-block'>
                          {close_filters}
                        </div>
                        <div className='d-lg-none'>
                          <svg onClick={() => this.handleShow()} width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5H26" stroke="black" strokeWidth="0.75" strokeLinecap="round"/>
                            <path d="M26 16.25H1" stroke="black" strokeWidth="0.75" strokeLinecap="round"/>
                            <circle cx="9.125" cy="4.375" r="4" fill="white" stroke="black" strokeWidth="0.75"/>
                            <circle cx="4.375" cy="4.375" r="4" transform="matrix(-1 0 0 1 22.25 11.25)" fill="white" stroke="black" strokeWidth="0.75"/>
                          </svg>
                        </div>
                        <DropdownButton
                          variant="light"
                          align="end"
                          className={styles.razdel_rcontent_sort}
                          title={`Сортировка: ` + sortName}
                        >
                          <Dropdown.Item className={styles.razdel_rcontent_sort_elm} onClick={() => this.changeSort( 'price_asc', `сначала дешевле` )}>Сначала дешевле</Dropdown.Item>
                          <Dropdown.Item className={styles.razdel_rcontent_sort_elm} onClick={() => this.changeSort( 'price_desc', `сначала дороже` )}>Сначала дороже</Dropdown.Item>
                          <Dropdown.Item className={styles.razdel_rcontent_sort_elm} onClick={() => this.changeSort( 'rand', `по популярности` )}>По популярности</Dropdown.Item>
                          <Dropdown.Item className={styles.razdel_rcontent_sort_elm} onClick={() => this.changeSort( 'updated_asc', `новинки` )}>По новизне</Dropdown.Item>
                        </DropdownButton>
                      </div>
                      {products != null ?
                        <>
                          {products.length > 0 ?
                            <>
                              <div className={styles.recomendedng_catalog}>
                                {products.map(( elm, i ) => {
                                  return (
                                    <Card key={i} className={elm.count > 0 ? styles.recomendedng_catalog_card_razdel : styles.recomendedng_catalog_card_razdel_null}>
                                      {loading &&
                                        <div className={styles.recomendedng_catalog_loading_plashka}>
                                          <Spinner animation="border" variant="dark" />
                                        </div>
                                      }
                                      <Card.Img alt={elm.name} className={styles.recomendedng_catalog_card_image} variant="top" src={elm.image} width="259" height="362" />
                                      <Card.Body className={styles.recomendedng_catalog_card_content}>
                                        <div className={styles.recomendedng_catalog_card_art}>Арт. {elm.article}</div>
                                        <a href={elm.url} className={styles.recomendedng_catalog_card_name + ` text-truncate stretched-link`}>{elm.name}</a>
                                        <div className='d-flex align-items-center justify-content-between'>
                                          <div className='d-flex align-items-center justify-content-start'>
                                            {elm.price > 0 &&
                                              <div className={styles.recomendedng_catalog_card_price}>
                                                {elm?.old_price > elm.price ? (
                                                  <>
                                                    <s>{this.priceFormat(elm.old_price)}</s>{` `}
                                                    <font color='red'>{this.priceFormat(elm.price)}</font>{` `}
                                                  </>
                                                ) : (
                                                  <>{this.priceFormat(elm.price)}{` `}</>
                                                )}
                                                <span>₽</span>
                                              </div>
                                            }
                                            <div className={styles.recomendedng_catalog_card_dot}></div>
                                            {elm.color != '' &&
                                              <OverlayTrigger overlay={<Tooltip id={`color_overlay_` + elm.id + `_` + i}>{elm.colorName}</Tooltip>}>
                                                <div style={{ backgroundColor: elm.color }} className={styles.recomendedng_catalog_card_color}></div>
                                              </OverlayTrigger>
                                            }
                                          </div>
                                          <div className='d-flex align-items-center justify-content-end'>
                                            <Button onClick={() => changeFavorite( elm.id )} className={styles.recomendedng_catalog_card_btn} variant={ favorite.includes( elm.id ) ? `danger` : `primary`}>
                                              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.02051 4.26339V13.4091C1.02051 14.7214 1.02051 15.3774 1.21732 15.779C1.58211 16.5232 2.38156 16.951 3.20316 16.8417C3.64643 16.7827 4.1924 16.4187 5.28433 15.6908L5.28695 15.689C5.71975 15.4005 5.93618 15.2562 6.16258 15.1762C6.5784 15.0292 7.03211 15.0292 7.44793 15.1762C7.67478 15.2563 7.89206 15.4012 8.32661 15.6909C9.41854 16.4189 9.96512 16.7825 10.4084 16.8415C11.23 16.9508 12.0294 16.5232 12.3942 15.779C12.591 15.3775 12.591 14.7212 12.591 13.4091V4.26022C12.591 3.18232 12.591 2.64256 12.381 2.23045C12.1961 1.8676 11.9004 1.5728 11.5375 1.38792C11.125 1.17773 10.5857 1.17773 9.50572 1.17773H4.10616C3.02615 1.17773 2.48574 1.17773 2.07323 1.38792C1.71037 1.5728 1.41558 1.8676 1.23069 2.23045C1.02051 2.64296 1.02051 3.18337 1.02051 4.26339Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                              </svg>
                                            </Button>
                                            {in_cart_loading ?
                                              <Button className={styles.recomendedng_catalog_card_btn} variant="primary">
                                                <Spinner style={{ width: `20px`, height: `20px` }} animation="border" variant="light" />
                                              </Button>
                                            :
                                              <Button onClick={() => showInCart( elm.id, elm.var_id )} className={styles.recomendedng_catalog_card_btn} variant={ this.inCart( elm.res_id ) ? `danger` : `primary`}>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M14.9129 15.4305C13.8035 15.4305 12.9042 16.3299 12.9042 17.4393C12.9042 18.5487 13.8035 19.448 14.9129 19.448C16.0223 19.448 16.9217 18.5487 16.9217 17.4393C16.9217 16.3299 16.0223 15.4305 14.9129 15.4305ZM14.9129 15.4305H7.17309C6.71001 15.4305 6.47805 15.4305 6.28739 15.3481C6.11921 15.2754 5.9733 15.1584 5.86699 15.0092C5.74783 14.8419 5.69991 14.6183 5.60505 14.1755L3.133 2.63933C3.03593 2.18634 2.98675 1.9601 2.86621 1.7909C2.75991 1.64168 2.61402 1.52423 2.44584 1.45155C2.25514 1.36914 2.02447 1.36914 1.56119 1.36914H0.851562M3.86471 4.38229H16.7944C17.5193 4.38229 17.8814 4.38229 18.1247 4.53331C18.3378 4.66559 18.4939 4.87305 18.5619 5.11449C18.6396 5.39012 18.5398 5.73817 18.3389 6.4347L16.9482 11.2557C16.828 11.6722 16.7679 11.88 16.6461 12.0346C16.5385 12.171 16.3966 12.2777 16.2357 12.3433C16.054 12.4174 15.8381 12.4174 15.4072 12.4174H5.60276M5.87348 19.448C4.76407 19.448 3.86471 18.5487 3.86471 17.4393C3.86471 16.3299 4.76407 15.4305 5.87348 15.4305C6.98289 15.4305 7.88224 16.3299 7.88224 17.4393C7.88224 18.5487 6.98289 19.448 5.87348 19.448Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                              </Button>
                                            }
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  )
                                })}
                                <div className='d-none d-lg-flex w-100 justify-content-end'>
                                  <BPagination className={styles.recomendedng_pagenav}>
                                    {[...Array( count )].map(( num, key ) => {
                                      num = key + 1
                                      return (
                                        <BPagination.Item href={`${ajax_data.url_ng}?page=${num}`} onClick={(e) => this.changePage( e, num )} key={key} active={num == page ? true : false}>{num}</BPagination.Item>
                                      )
                                    })}
                                    {page < count &&
                                      <BPagination.Next href={`${ajax_data.url_ng}?page=${page - 1 + 2}`} onClick={(e) => this.changePage( e, page - 1 + 2 )}>След →</BPagination.Next>
                                    }
                                  </BPagination>
                                </div>
                                <div className='d-flex d-lg-none w-100 justify-content-center'>
                                  <BPagination className={styles.recomendedng_pagenav}>
                                    {[...Array( count )].map(( num, key ) => {
                                      num = key + 1
                                      return (
                                        <BPagination.Item href={`${ajax_data.url_ng}?page=${num}`} onClick={(e) => this.changePage( e, num )} key={key} active={num == page ? true : false}>{num}</BPagination.Item>
                                      )
                                    })}
                                    {page < count &&
                                      <BPagination.Next href={`${ajax_data.url_ng}?page=${page - 1 + 2}`} onClick={(e) => this.changePage( e, page - 1 + 2 )}>След →</BPagination.Next>
                                    }
                                  </BPagination>
                                </div>
                              </div>
                              {new_page &&
                                <Button href={page_data.man_link} variant='dark' className='w-100 mt-2'>Смотреть все</Button>
                              }
                            </>
                          :
                            <div style={{ height: `800px` }} className='d-flex w-100 align-items-center justify-content-center'>
                              <div>По вашему запросу не найдено товаров, попробуйте изменить параметры фильтра</div>
                            </div>
                          }
                        </>
                      :
                        <div style={{ height: `800px` }} className='d-flex w-100 align-items-center justify-content-center'>
                          <Spinner animation="border" variant="dark" />
                        </div>
                      }
                    </div>
                  </div>
                  {ajax_data.content != '' &&
                    <div dangerouslySetInnerHTML={{__html: ajax_data.content}}></div>
                  }
                </Container>
              </div>
              {new_page ?
                <Lists
                  title={`ТАКЖЕ РЕКОМЕНДУЕМ`}
                  products={recomended}
                  showInCart={showInCart}
                  in_cart_loading={in_cart_loading}
                  favorite={favorite}
                  changeFavorite={changeFavorite}
                  cart={cart}
                  link={page_data.man_link}
                />
              :
                <>
                  <RecomendedNg
                    title={`НОВЫЕ ПОСТУПЛЕНИЯ`}
                    text={`Посмотрите наши последние поступления дизайнерской одежды и подберите свой стиль`}
                    showInCart={showInCart}
                    in_cart_loading={in_cart_loading}
                    favorite={favorite}
                    changeFavorite={changeFavorite}
                    cart={cart}
                    link={page_data.new_link}
                    variant={`new`}
                    start={ajax_data?.new_products || { page: 1, paginator: [], products: [] }}
                  />
                  <FeedbackNg
                    ajax_data={ajax_data}
                  />
                </>
              }
              <Offcanvas show={show} onHide={() => this.handleClose()}>
                <Offcanvas.Header className={styles.ofconvas_filter_h} closeButton />
                <Offcanvas.Body>
                  {filtr}
                </Offcanvas.Body>
              </Offcanvas>
            </>
          :
            <div style={{ height: `800px` }} className='d-none d-lg-flex w-100 align-items-center justify-content-center'>
              <Spinner animation="border" variant="dark" />
            </div>
          }
        </div>
      </>
    )
  }
}

Razdel.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool,
  catalogmenu: PropTypes.array,
  new_page: PropTypes.bool
}